var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewBtnSnsLoginApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.327 18.562a5.005 5.005 0 0 0 1.858-.545 4.74 4.74 0 0 0 1.477-1.196 5.386 5.386 0 0 0 1.335-3.354 2.543 2.543 0 0 0 0-.467c-1.423.146-2.727.817-3.63 1.867a5.076 5.076 0 0 0-1.334 3.24 1.414 1.414 0 0 0 0 .43l.294.025zM22.417 37c1.522 0 2.189-.996 4.083-.996 1.895 0 2.349.97 4.003.97s2.762-1.5 3.803-2.963A13.25 13.25 0 0 0 36 30.618a5.5 5.5 0 0 1-2.41-1.958 5.062 5.062 0 0 1-.886-2.884 5.24 5.24 0 0 1 .72-2.61 5.612 5.612 0 0 1 1.949-1.968 5.633 5.633 0 0 0-2.11-1.77 5.997 5.997 0 0 0-2.747-.601c-1.868 0-3.389 1.097-4.336 1.097-.947 0-2.388-1.034-4.003-1.034-3.068 0-6.177 2.522-6.177 7.125.06 2.82.952 5.567 2.575 7.933C19.83 35.625 20.883 37 22.418 37z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBtnSnsLoginApple);
export default __webpack_public_path__ + "static/media/new_btn_sns_login_apple.63cbe589ebd3768807cb0f82ed4dc63a.svg";
export { ForwardRef as ReactComponent };